<template>
	<b-container>
		<b-row v-if="quote.Mail == 0" class="mt-3">
			<b-col>
				<b-link class="float-right ml-3" @click.prevent="viewQuote" title="Preview / Download">
					<b-icon font-scale="1.5" icon="eye"></b-icon>
				</b-link>

				<b-link class="float-right ml-3" @click.prevent="userSaveQuote" title="Save">
					<b-icon font-scale="1.5" icon="check2-square"></b-icon>
				</b-link>
			</b-col>
		</b-row>

		<b-row v-else class="mt-3">
			<b-col>
				<b-link class="float-right ml-3" @click.prevent="viewQuote" title="Preview / Download">
					<b-icon font-scale="1.5" icon="eye"></b-icon>
				</b-link>

				<b-link v-if="quote.Status == 0" class="float-right ml-3" @click.prevent="declineQuote" title="Decline">
					<b-icon font-scale="1.5" icon="emoji-frown"></b-icon>
				</b-link>

				<b-link v-if="quote.Status == 0" class="float-right ml-3" @click.prevent="acceptQuote" title="Accept">
					<b-icon font-scale="1.5" icon="emoji-smile"></b-icon>
				</b-link>
			</b-col>
		</b-row>

		<b-form @submit.prevent>
			<b-row class="mt-3">
				<b-col cols="12">
					<h1>Job: {{ job.Id }} - Quote</h1>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col cols="12">
					<h4>Dates and revisions</h4>

					<b-card bg-variant="light">
						<b-card-text>
							<p v-if="quote.ParentQuote">
								{{ formatDate(quote.ParentQuote.Sent) }}
							</p>

							<p v-else-if="quote.Mail == 1">
								{{ formatDate(quote.Sent) }}
							</p>

							<p>Revised: {{ formatDate(quote.Added) }}</p>
						</b-card-text>
					</b-card>
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<h4>Quote Contact</h4>

					<b-card bg-variant="light">
						<b-card-text>
							<p>
								<b-link href="#" @click.prevent="editContact(job.Contact.Id, null)">{{ job.Contact.Name }}</b-link>
							</p>
							<p>{{ job.Contact.Telephone }}</p>
							<p>{{ job.Contact.EmailAddress }}</p>
							<p>{{ job.Contact.Address.Address1 }}</p>
							<p>{{ job.Contact.Address.Address2 }}</p>
							<p>{{ job.Contact.Address.Address3 }}</p>
							<p>{{ job.Contact.Address.Town }}</p>
							<p>{{ job.Contact.Address.County }}</p>
							<p>{{ job.Contact.Address.Postcode }}</p>
						</b-card-text>
					</b-card>
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<h4>Intro and report</h4>

					<quill-editor ref="IntroductionEditor" :options="editorOptions" @focus="onEditorFocus" v-model="quote.Introduction" :disabled="quote.Mail == 1 ? true : false" />
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<b-card class="mb-3" bg-variant="light" v-for="(block, index) in quoteBlocks" :key="index">
						<b-card-text>
							<b-col cols="11" class="mb-3">
								<b-form-input v-model="block.Title" type="text" placeholder="Quote Description" :readonly="quote.Mail == 1 ? true : false" />
							</b-col>

							<b-col class="mt-3">
								<h4>Attend on site</h4>

								<draggable v-model="quoteBlocks[index].QuoteLines[0]" handle=".handle" @end="setOrder">

									<b-row class="mt-3 mb-3" v-for="(line, lineIndex) in quoteBlocks[index].QuoteLines[0]" :key="`${lineIndex}-0`">

										<b-col cols="7">

											<b-form-textarea id="textarea" v-model="line.Title" placeholder="Description..." rows="2" max-rows="2" :readonly="quote.Mail == 1 ? true : false"></b-form-textarea>

										</b-col>


										<b-col>
											<b-input-group append="Hr">
												<b-form-input v-model="line.Hours" type="number" min="0" step="0.5" placeholder="Hours" :readonly="quote.Mail == 1 ? true : false" />
											</b-input-group>
										</b-col>

										<b-col>
											<b-input-group prepend="£">
												<b-form-input v-model="line.Rate" type="number" min="0" step="0.5" placeholder="Rate" :readonly="quote.Mail == 1 ? true : false" />
											</b-input-group>
										</b-col>
										

										<b-col cols="1.5" class="text-right">
											<b-button v-if="quote.Mail == 0" variant="link" title="Remove this item" @click.prevent="deleteLine(index, 0, lineIndex)">
												<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
											</b-button>

											<b-button variant="link" title="Change order">
												<b-icon class="handle" font-scale="1.5" icon="list"></b-icon>
											</b-button>
										</b-col>




										<b-col cols="12">
											<hr>
										</b-col>

									</b-row>



								</draggable>

								<b-link v-if="quote.Mail == 0" @click.prevent="addLine(index, 0)">
									<b-icon font-scale="1.5" icon="plus-square"></b-icon>
								</b-link>




							</b-col>

							<b-col class="mt-3">
								<h4>In our workshop</h4>

								<draggable v-model="quoteBlocks[index].QuoteLines[1]" handle=".handle" @end="setOrder">

									<b-row class="mt-3 mb-3" v-for="(line, lineIndex) in quoteBlocks[index].QuoteLines[1]" :key="`${lineIndex}-1`">
										<b-col cols="7">

											<b-form-textarea id="textarea" v-model="line.Title" placeholder="Description..." rows="2" max-rows="2" :readonly="quote.Mail == 1 ? true : false"></b-form-textarea>

										</b-col>


										<b-col>
											<b-input-group append="Hr">
												<b-form-input v-model="line.Hours" type="number" min="0" step="0.5" placeholder="Hours" :readonly="quote.Mail == 1 ? true : false" />
											</b-input-group>
										</b-col>

										<b-col>
											<b-input-group prepend="£">
												<b-form-input v-model="line.Rate" type="number" min="0" step="0.5" placeholder="Rate" :readonly="quote.Mail == 1 ? true : false" />
											</b-input-group>
										</b-col>

										<b-col cols="1.5" class="text-right">
											<b-button v-if="quote.Mail == 0" variant="link" title="Remove this item" @click.prevent="deleteLine(index, 1, lineIndex)">
												<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
											</b-button>

											<b-button variant="link" title="Change order">
												<b-icon class="handle" font-scale="1.5" icon="list"></b-icon>
											</b-button>
										</b-col>




										<b-col cols="12">
											<hr>
										</b-col>
									</b-row>

								</draggable>

								<b-link v-if="quote.Mail == 0" @click.prevent="addLine(index, 1)">
									<b-icon font-scale="1.5" icon="plus-square"></b-icon>
								</b-link>
							</b-col>

							<b-col class="mt-3">
								<h4>Return to site</h4>

								<draggable v-model="quoteBlocks[index].QuoteLines[2]" handle=".handle" @end="setOrder">


									<b-row class="mt-3 mb-3" v-for="(line, lineIndex) in quoteBlocks[index].QuoteLines[2]" :key="`${lineIndex}-2`">

										<b-col cols="7">

											<b-form-textarea id="textarea" v-model="line.Title" placeholder="Description..." rows="2" max-rows="2" :readonly="quote.Mail == 1 ? true : false"></b-form-textarea>

										</b-col>


										<b-col>
											<b-input-group append="Hr">
												<b-form-input v-model="line.Hours" type="number" min="0" step="0.5" placeholder="Hours" :readonly="quote.Mail == 1 ? true : false" />
											</b-input-group>
										</b-col>

										<b-col>
											<b-input-group prepend="£">
												<b-form-input v-model="line.Rate" type="number" min="0" step="0.5" placeholder="Rate" :readonly="quote.Mail == 1 ? true : false" />
											</b-input-group>
										</b-col>

										<b-col cols="1.5" class="text-right">
											<b-button v-if="quote.Mail == 0" variant="link" title="Remove this item" @click.prevent="deleteLine(index, 2, lineIndex)">
												<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
											</b-button>

											<b-button variant="link" title="Change order">
												<b-icon class="handle" font-scale="1.5" icon="list"></b-icon>
											</b-button>
										</b-col>

										<b-col cols="12">
											<hr>
										</b-col>
									</b-row>

								</draggable>

								<b-link v-if="quote.Mail == 0" @click.prevent="addLine(index, 2)">
									<b-icon font-scale="1.5" icon="plus-square"></b-icon>
								</b-link>
							</b-col>


							<b-col class="mt-3 mb-3">

								<h4>Travel </h4>

								<b-row class="mt-3 mb-3">

									<b-col cols="4">

										<b-input-group append="Mls">
											<b-form-input v-model="block.Miles" type="number" min="0" step="0.5" placeholder="Miles" :readonly="quote.Mail == 1 ? true : false" />
										</b-input-group>

									</b-col>

									<b-col cols="4">

										<b-input-group append="Hrs">
											<b-form-input v-model="block.Time" type="number" min="0" step="0.5" placeholder="Hours" :readonly="quote.Mail == 1 ? true : false" />
										</b-input-group>
									</b-col>

									<b-col>

										<b-input-group prepend="£">
											<b-form-input v-model="block.TravelTotal" type="number" min="0" step="0.5" placeholder="0.00" :readonly="true" />
										</b-input-group>

									</b-col>

									<b-col class="text-right">
									</b-col>
								</b-row>

							</b-col>

							<b-col cols="5" lg="2" class="mt-3 mb-3">
								<b-form-group label="Cost" for="cost">
									<b-input-group prepend="£">
										<b-form-input v-model="block.Cost" type="number" min="0" step="0.5" :readonly="quote.Mail == 1 ? true : false" />
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-card-text>
					</b-card>

					<b-button v-if="quote.Mail == 0" @click.prevent="addBlock">Add Quote</b-button>
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<h4>Exclusions and notes</h4>

					<quill-editor ref="ExclusionsEditor" :options="editorOptions" @focus="onEditorFocus($event)" v-model="quote.Exclusions" :disabled="quote.Mail == 1 ? true : false" />
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<b-card bg-variant="light">
						<h4>Quote terms will be added here automatically</h4>
					</b-card>
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<h4>Signature Block</h4>
					<b-row>
						<b-col cols="6">
							<b-form-group label="Signed off by" for="assignees">
								<v-select v-if="engineers.length" v-model="quote.SignatureUser" label="FullName" :options="engineers" @input="setSignatureUser"></v-select>
							</b-form-group>
						</b-col>

						<b-col cols="6">
							<pre v-if="quote.SignatureUser">{{ quote.SignatureUser.SignatureBlock }}</pre>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-form>

		<b-modal id="sharedModal" ref="sharedModal" size="lg" :title="modalTitle" hide-footer>
			<edit-contact v-if="modalContent == 'edit-contact'" @updateContact="updateContact" :editing="editing" />

			<quote-images v-if="modalContent == 'quote-image'" :clockId="job.ClockId" @select="onImageSelected" />

			<div v-if="modalContent == 'choose-block'">
				<b-card class="mb-3" bg-variant="light" v-for="(block, index) in quoteBlocks" :key="index">
					<b-card-text class="d-flex justify-content-start">
						<span class="p-2">
							<b-form-checkbox v-model="block.selected" size="lg"></b-form-checkbox>
						</span>

						<span class="p-2">{{ block.Title }}</span>
						<span class="p-2">&pound;{{ block.Cost | localNumber }}</span>
					</b-card-text>
				</b-card>

				<b-button variant="outline-success" v-if="selectedQuoteBlocks > 0" title="Accept quote(s)" @click="finalizeAcceptQuote">
					<b-icon font-scale="1.5" icon="check-square" variant="success"></b-icon>
					Create Tasks
				</b-button>
			</div>
		</b-modal>

		<b-modal id="quoteModal" ref="quoteModal" size="xl">
			<b-embed type="iframe" id="quoteframe" ref="quoteFrame" :src="viewQuotePath" allowfullscreen></b-embed>

			<template #modal-footer>
				<b-button v-if="quote.Status < 2" variant="outline-primary" title="Downlaod PDF" @click="downloadQuote">
					<b-icon font-scale="1.5" icon="box-arrow-down"></b-icon>
					Download
				</b-button>

				<b-button v-if="quote.Status < 2" variant="outline-primary" title="Open email" @click="openMailTo">
					<b-icon font-scale="1.5" icon="envelope"></b-icon>
					Open Email
				</b-button>

				<b-button variant="outline-primary" v-if="quote.Mail == 0" title="Set as sent" @click="sendQuote">
					<b-icon font-scale="1.5" icon="mailbox"></b-icon>
					Set as sent
				</b-button>
			</template>
		</b-modal>

		<confirm ref="confirm"></confirm>
	</b-container>
</template>

<script>
import JobService from '@/api-services/job.service';
import QuoteService from '@/api-services/quote.service';
import AccountService from '@/api-services/account.service';

import EditContact from '@/components/partials/edit-contact';
import QuoteImages from '@/components/partials/quote-images';
import Confirm from '@/components/partials/confirm';
import Draggable from 'vuedraggable';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import { dateFuncs } from '@/globs.js';

function createTask(title, type, subType) {
	return {
		TaskType: type,
		Title: title,
		Hours: 0,
		Order: 0,
		TaskSubType: subType
	};
}

export default {
	name: 'quoteCreate',

	components: {
		EditContact,
		quillEditor,
		QuoteImages,
		Confirm,
		Draggable,
		VSelect
	},

	filters: {
		localNumber(value) {
			return Number(value).toLocaleString();
		}
	},

	data() {
		return {
			quote: {
				JobId: this.$router.currentRoute.params.id,
				QuoteId: null,
				ApplicationUserId: null,
				Reference: null,
				Revision: null,
				Added: dateFuncs.today(),
				Sent: null,
				Mail: null,
				Status: null,
				Introduction: '',
				Exclusions: '',
				QuoteBlocks: [],
				SignatureUser: {}
			},

			job: {
				Contact: {
					Address: {}
				}
			},

			quoteBlocks: [
				{
					Title: null,
					Cost: 0,
					QuoteLines: [[], [], []]
				}
			],

			revision: this.$router.currentRoute.params.revision ? true : false,

			editing: {
				id: null,
				index: null
			},

			engineers: [],

			modalContent: null,
			modalTitle: 'Select',

			creating: false,
			detailsEditable: false,

			editorFocused: null,
			editorOptions: {
				theme: 'snow',
				modules: {
					toolbar: {
						container: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], [{ script: 'sub' }, { script: 'super' }], [{ header: [1, 2, 3, false] }], [{ indent: '-1' }, { indent: '+1' }], ['image', 'link']],

						handlers: {
							image: this.onSelectImageClick
						}
					}
				}
			}
		};
	},

	created() {
		this.fetchJob();
		this.fetchQuote();

		this.fetchEngineers();
	},

	computed: {
		viewQuotePath() {
			let route = this.$router.resolve({
				name: 'quoteview',
				params: { id: this.quote.Id }
			});
			return window.location.origin + route.href;
		},

		selectedQuoteBlocks() {
			return this.quoteBlocks.filter((obj) => obj.selected == true).length;
		}
	},

	methods: {
		onEditorFocus(quill) {
			this.editorFocused = quill;
		},

		onSelectImageClick() {
			if (this.editorFocused) {
				this.modalContent = 'quote-image';
				this.modalTitle = 'Select Image';
				this.$refs.sharedModal.show();
			}
		},

		onImageSelected(img) {
			this.editorFocused.insertEmbed(this.editorFocused.getSelection(true).index, 'image', img.source, '');
			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		addBlock() {
			this.quoteBlocks.push({
				Title: '',
				Cost: 0,
				QuoteLines: [[], [], []]
			});
		},


		addLine(index, taskType) {
			// push to correct array.

			this.quoteBlocks[index].QuoteLines[taskType].push({
				Title: '',
				Hours: 0,
				Order: 0,
				TaskType: taskType
			});

			this.quoteBlocks[index].QuoteLines[taskType].forEach((line, i) => {
				line.Order = i;
			});

		},

		deleteBlock(index) {
			this.quoteBlocks.splice(index, 1);
		},

		deleteLine(index, taskType, indexSection) {
			let typeArr = this.quoteBlocks[index].QuoteLines[taskType];
			typeArr.splice(indexSection, 1);
		},

		editContact(contactId, index) {
			this.editing.id = contactId;
			this.editing.index = index;

			this.$nextTick(() => {
				this.modalContent = 'edit-contact';
				this.modalTitle = 'Edit Contact';
				this.$refs.sharedModal.show();
			});
		},

		updateContact(contactFromForm) {
			this.quote.Contact = contactFromForm;

			this.editing = {
				id: null,
				index: null
			};

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		formatDate(date) {
			return dateFuncs.humanDateFormat(date);
		},

		fetchJob() {
			JobService.get(this.$router.currentRoute.params.id).then((response) => {
				this.job = response.data;
			});
		},

		fetchQuote() {
			QuoteService.get(this.$router.currentRoute.params.quote).then((response) => {
				this.quote = response.data;
				this.quote.Added = dateFuncs.today();

				if (this.revision) {
					// we actually want to make a new quote and go to it.
					this.updateQuote();
				} else {
					this.quote.QuoteBlocks.forEach((quoteBlock, blockIndex) => {
						if (!this.quoteBlocks[blockIndex]) {
							this.addBlock();
						}
						this.quoteBlocks[blockIndex].Id = quoteBlock.Id;
						this.quoteBlocks[blockIndex].Title = quoteBlock.Title;
						this.quoteBlocks[blockIndex].Cost = quoteBlock.Cost;

						quoteBlock.QuoteLines.forEach((quoteLine) => {
							// push them into the correct array for it's type
							this.quoteBlocks[blockIndex].QuoteLines[quoteLine.TaskType].push(quoteLine);
						});

						// order each tasktype block by line order...
						this.quoteBlocks[blockIndex].QuoteLines.forEach((quoteTaskTaskType) => {
							quoteTaskTaskType.sort((a, b) => {
								return a.Order - b.Order;
							});
						});


					});

					this.quote.QuoteBlocks = [];
				}
			});
		},

		viewQuote() {
			// save any changes
			if (this.quote.Mail == 0) {
				this.updateQuote();
			}

			this.$nextTick(() => {
				this.$refs.quoteModal.show();
			});
		},

		downloadQuote() {
			// postmessage emits a message with this signature, the iframe template has a listener to pick it up.
			document.getElementById('quoteframe').contentWindow.postMessage(
				{
					event_id: 'download_' + this.quote.Id,
					ref: this.quote.Reference,
					rev: this.quote.Revision
				},
				'*'
			);
		},

		sendQuote() {
			// fill in sent date and set mailstatus to "sent"
			this.quote.Mail = 1;
			this.quote.Sent = dateFuncs.today();

			// we need to log this part in the API. check fields.

			this.updateQuote();

			this.$nextTick(() => {
				this.$refs.quoteModal.hide();
			});
		},

		openMailTo() {
			let mailto = `mailto:${this.job.Contact.EmailAddress}
			?subject=Quote no.${this.quote.Reference} for ${this.job.Clock.Name}`;
			console.log(mailto);
			window.location = mailto;
		},

		acceptQuote() {
			this.modalContent = 'choose-block';
			this.modalTitle = 'Choose quotes to accept';
			this.$refs.sharedModal.show();
		},

		finalizeAcceptQuote() {
			// get a clone
			let cloneBlocks = JSON.parse(JSON.stringify(this.quoteBlocks));

			// flatten the inner quotelines array and concat to new array of tasks
			let flattened = [];
			let toWrapAttend = false;
			let toWrapReturn = false;

			cloneBlocks.forEach(function (quoteBlock) {
				// only if it was selected for approval
				if (quoteBlock.selected) {
					if (quoteBlock.QuoteLines[0].length > 0) {
						// we have some attend on site tasks to wrap.
						toWrapAttend = true;
					}

					if (quoteBlock.QuoteLines[2].length > 0) {
						// we have some return to site tasks to wrap.
						toWrapReturn = true;
					}

					flattened = flattened.concat(quoteBlock.QuoteLines.flat(2));
				}
			});

			console.log(toWrapAttend);
			console.log(toWrapReturn);


			// get rid of the Id field as these are new tasks
			let reduced = flattened.map(({ Id, ...keepAttrs }) => keepAttrs);

			// was this flag set?
			if (toWrapAttend) {
				let checkIn = createTask('Check in', 0, 0);
				let checkOut = createTask('Check out', 0, 2);

				reduced.unshift(checkIn);
				reduced.push(checkOut);
			}

			if (toWrapReturn) {
				let checkIn = createTask('Check in', 2, 0);
				let checkOut = createTask('Check out', 2, 2);

				reduced.unshift(checkIn);
				reduced.push(checkOut);
			}


			// order by type so they are logical in task order
			reduced.sort((a, b) => (a.TaskType > b.TaskType ? 1 : b.TaskType > a.TaskType ? -1 : 0));

			this.quote.Status = 1;

			this.updateQuote().then((res) => {
				let newAssignments = {
					Assignments: reduced
				};

				JobService.createAssignments(this.job.Id, newAssignments)
					.then(() => {
						this.$router.push({
							name: 'jobupdate',
							params: { id: this.quote.JobId }
						});
					})
					.catch((error) => {
						this.handleError(error);
					});
			});
		},

		declineQuote() {
			this.quote.Status = 2;

			this.updateQuote().then((res) => {
				this.$router.push({
					name: 'jobupdate',
					params: { id: this.quote.JobId }
				});
			});
		},

		userSaveQuote() {
			this.updateQuote().then((res) => {
				let modal_options = {
					text: 'light',
					background: 'success'
				};

				this.$refs.confirm.open('Success', 'Finished editing this quote?', false, modal_options).then((confirm) => {
					if (confirm) {
						this.$router.push({
							name: 'jobupdate',
							params: { id: this.quote.JobId }
						});
					}
				});
			});
		},

		updateQuote() {
			if (this.revision) {
				// original quote becomes parent, unless it already has a parent

				if (this.quote.QuoteId == null) {
					this.quote.QuoteId = this.quote.Id;
				}

				// reset these
				this.quote.Mail = 0;
				this.quote.Status = 0;
				this.quote.Sent = null;

				// force a new record
				delete this.quote.Id;

				return QuoteService.create(this.quote)
					.then((res) => {
						this.quote.Id = res.data.Id;
						this.revision = false;

						// redirect to the new thing

						this.$router.push({
							name: 'quoteupdate',
							params: {
								id: this.quote.JobId,
								quote: res.data.Id
							}
						});

						this.fetchQuote();
					})
					.catch((error) => {
						this.handleError(error);
					});
			} else {
				// unpack all the quotelines into the real deal.
				let cloneBlocks = JSON.parse(JSON.stringify(this.quoteBlocks));

				// clear the quote so we don't include any previously send quote blocks
				this.quote.QuoteBlocks = [];

				cloneBlocks.forEach((quoteBlock, i) => {
					this.quote.QuoteBlocks.push(quoteBlock);
					this.quote.QuoteBlocks[i].QuoteLines = quoteBlock.QuoteLines.flat(2);
				});

				return QuoteService.update(this.quote.Id, this.quote)
					.then((res) => { })
					.catch((error) => {
						this.handleError(error);
					});
			}
		},

		fetchEngineers() {
			AccountService.getAll()
				.then((response) => {
					this.engineers = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		setSignatureUser(selectedUser) {
			this.quote.ApplicationUserId = selectedUser.Id;
		},

		setOrder() {
			this.quoteBlocks.forEach((quoteBlock, blockIndex) => {
				// order each tasktype block by line order...
				this.quoteBlocks[blockIndex].QuoteLines.forEach((quoteTaskTaskType) => {
					quoteTaskTaskType.forEach((line, i) => {
						line.Order = i;
					});
				});
			});
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};
			let message;

			if (err.response.data != '') {

				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;

			} else {

				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/quote/quote-update.vue